import { useTheme } from '@emotion/react';
import { Button, Dialog, Stack, Typography } from '@mui/material';
import React from 'react';
import { useRef } from 'react';
import { buttonStyle2, dialogButtonCancel } from '../../../../utils/commonStyle';
import { Form, Formik } from 'formik';
import FormTextField from '../../../../components/FormTextField';
import * as yup from 'yup';
import ModalHeader from '../../../../components/ModalHeader';
import FileUploadField from '../../../../components/FileUploadField/FileUploadField';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../../../../redux/features/appSlice';
import appapi from '../../../../api/apiClient';
import { showmessage } from '../../../../utils/toastr';
import uploadFileToS3 from '../../../../utils/fileUpload';
import { useTranslation } from 'react-i18next';

const validationSchema = yup.object({
  subject: yup.string('Subject').min(3, 'Subject should be atleast 3 character').max(50, 'Maximum Character Limit 50').required(' '),
  message: yup.string('Message').min(1, 'Message should be atleast 3 character').max(50, 'Maximum Character Limit 50').required(' '),
  attachement: yup.string('Attachement').required(' '),
  url: yup
    .string()
    .nullable()
    .required()
    .matches(/[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/gi, 'Enter valid url!'),
});

const sx = {
  '& .MuiDialog-container': {
    alignItems: 'center',
    WebkitAlignItems: 'center',
    WebkitBoxAlign: 'center',
  },
  '& .MuiPaper-root': {
    width: '560px',
    height: '100%',
    borderRadius: '4px',
    maxWidth: '736px',
    maxHeight: 'calc(100%)',
    // overflow: 'hidden'
  },
};

export default function SendReport({ onModelHandleClose, modelOpen, compnayIds }) {
  const formRef = useRef();
  const theme = useTheme();
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.auth);
  const {t} = useTranslation()

  const handleSendReport = async (values) => {
    dispatch(setLoading(true));
    if (values.attachement && values.attachement?.path) {
      try {
        values['attachement'] = await uploadFileToS3(values.attachement);
      } catch (e) {}
    }
    const payload = {
      companyId: compnayIds,
      ...values,
    };
    const response = await appapi.post(`/client-management/addMarketInteligenceReport`, payload);
    if (response.ok) {
      dispatch(setLoading(false));
      const data = response.data;
      if (data.status === '7400') {
        onModelHandleClose(true);
        showmessage(data.message);
      } else {
        showmessage(data.message, 'error');
      }
    } else {
      dispatch(setLoading(false));
      showmessage(`Something Went Wrong!`, 'error', 2000);
    }
  };

  const handleFile = async (file) => {
    if (file?.path) {
      formRef?.current?.setFieldValue('attachement', file);
    } else {
      formRef?.current?.setFieldValue('attachement', undefined);
    }
  };

  return (
    <Dialog
      sx={sx}
      open={modelOpen}
      PaperProps={{ sx: { position: 'fixed', top: 0, right: 0, m: 0 } }}
    >
      <ModalHeader
        label={t('SEND MARKET INSIGHT REPORT')}
        onClose={() => onModelHandleClose(false)}
      />
      <Stack
        style={{ backgroundColor: '#8993AC26', width: '100%', height: '2px' }}
        className=""
      />
      <Stack
        style={{ backgroundColor: '#FFFFFF' }}
        flex={1}
      >
        <Formik
          innerRef={formRef}
          enableReinitialize={false}
          initialValues={{
            traderId: user?.companyId,
            subject: '',
            message: '',
            attachment: '',
            url: '',
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            handleSendReport(values);
          }}
        >
          {({ name, values, touched, errors, handleChange, handleBlur, isValid, dirty, setFieldValue, setFieldTouched }) => (
            <Form
              className="flex flex-col flex-1"
              autoComplete="off"
            >
              <Stack
                flexGrow={1}
                className="relative"
              >
                <Stack className="flex-overflow">
                  <Stack
                    style={{ backgroundColor: '#F2F3F580', borderRadius: '8px', borderWidth: '1px', borderColor: '#8993AC26' }}
                    className="m-[15px] p-[16px]"
                  >
                    <Stack>
                      <FormTextField
                        outlineLabel={t('Subject')}
                        name="subject"
                        requiredMark={true}
                        whiteSpace={true}
                        inputProps={{ maxLength: 51 }}
                      />
                    </Stack>
                    <Stack>
                      <FormTextField
                        outlineLabel={t('Message')}
                        name="message"
                        maxRows={3}
                        requiredMark={true}
                        whiteSpace={true}
                        inputProps={{ maxLength: 51 }}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            minHeight: '88px !important',
                            display: 'block',
                          },
                        }}
                      />
                    </Stack>
                    <Stack className="mb-[24px]">
                      <FileUploadField
                        placeholder={t('Upload File (CSV, XLSX, PDF)')}
                        // url={cr ? cr : null}
                        inputId={`doc1`}
                        handleFile={(files) => handleFile(files, 'Certificate of Registry')}
                        showFileName={true}
                        fileName="Certificate of Registry"
                        bgColor={'#f3f4f7'}
                        height={'40px'}
                        enableExcel={true}
                      />
                    </Stack>
                    <Stack>
                      <FormTextField
                        outlineLabel={t('Web URL')}
                        name="url"
                        requiredMark={true}
                        whiteSpace={true}
                        inputProps={{ maxLength: 101 }}
                      />
                    </Stack>
                  </Stack>
                </Stack>
              </Stack>
              <Stack
                direction="row"
                justifyContent="flex-end"
                className="px-4 py-2"
                style={{ backgroundColor: '#FFFFFF', zIndex: 1 }}
              >
                <Button
                  sx={[
                    dialogButtonCancel,
                    {
                      color: theme.palette.primary.main,
                      '&:hover': {
                        // backgroundColor: theme.palette.secondary.main,
                        // color: theme.palette.background.main,
                        // borderColor: theme.palette.secondary.main,
                      },
                    },
                  ]}
                  style={{ width: '128px', marginLeft: '80px', height: '40px' }}
                  onClick={() => {
                    onModelHandleClose(false);
                  }}
                >
                  {t('Close')}
                </Button>
                <Button
                  sx={[
                    buttonStyle2,
                    {
                      color: '#fff',
                      backgroundColor: theme.palette.primary.main,
                      textTransform: 'uppercase',
                      '&:hover': {
                        backgroundColor: theme.palette.background.main,
                        color: '#fff',
                      },
                      '&:disabled': {
                        color: 'rgba(255,255,255,0.5)',
                        backgroundColor: theme.palette.primary.main,
                      },
                    },
                  ]}
                  style={{ width: '128px', height: '40px' }}
                  disabled={!(dirty && isValid)}
                  type="submit"
                  variant="contained"
                >
                  {t('Send')}
                </Button>
              </Stack>
            </Form>
          )}
        </Formik>
      </Stack>
    </Dialog>
  );
}
